import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const PhoneInput = ({
  input, label, meta: { error }, disabled,
}) =>
  (<TextField
    {...input}
    floatingLabelText={label}
    errorText={error}
    fullWidth
    type="tel"
    disabled={disabled}
  />);

PhoneInput.defaultProps = {
  label: '',
};

PhoneInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.node,
  disabled: PropTypes.bool,
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/components/form/PhoneInput.js